import Accessibility from '@material-ui/icons/Accessibility';
import AirlineSeatFlatAngled from '@material-ui/icons/AirlineSeatFlatAngled';
import AspectRatio from '@material-ui/icons/AspectRatio';
import Assignment from '@material-ui/icons/Assignment';
import AssignmentReturn from '@material-ui/icons/AssignmentReturn';
import Attachment from '@material-ui/icons/Attachment';
import AttachMoney from '@material-ui/icons/AttachMoney';
import Autorenew from '@material-ui/icons/Autorenew';
import Ballot from '@material-ui/icons/Ballot';
import BarChart from '@material-ui/icons/BarChart';
import Cached from '@material-ui/icons/Cached';
import CalendarToday from '@material-ui/icons/CalendarToday';
import CalendarViewDay from '@material-ui/icons/CalendarViewDay';
import CloudQueue from '@material-ui/icons/CloudQueue';
import CloudUpload from '@material-ui/icons/CloudUpload';
import ContactMail from '@material-ui/icons/ContactMail';
import Create from '@material-ui/icons/Create';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DateRange from '@material-ui/icons/DateRange';
import Done from '@material-ui/icons/Done';
import Face from '@material-ui/icons/Face';
import FormatLineSpacing from '@material-ui/icons/FormatLineSpacing';
import Gavel from '@material-ui/icons/Gavel';
import Gradient from '@material-ui/icons/Gradient';
import Group from '@material-ui/icons/Group';
import Layers from '@material-ui/icons/Layers';
import LibraryAdd from '@material-ui/icons/LibraryAdd';
import List from '@material-ui/icons/List';
import LocationCity from '@material-ui/icons/LocationCity';
import Loop from '@material-ui/icons/Loop';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Payment from '@material-ui/icons/Payment';
import PeopleIcon from '@material-ui/icons/People';
import Person from '@material-ui/icons/Person';
import PersonAdd from '@material-ui/icons/PersonAdd';
import Print from '@material-ui/icons/Print';
import Receipt from '@material-ui/icons/Receipt';
import RemoveRedEye from '@material-ui/icons/RemoveRedEye';
import Replay30 from '@material-ui/icons/Replay30';
import Rowing from '@material-ui/icons/Rowing';
import Search from '@material-ui/icons/Search';
import Settings from '@material-ui/icons/Settings';
import SwapHoriz from '@material-ui/icons/SwapHoriz';
import SwapVert from '@material-ui/icons/SwapVert';
import TrendingDown from '@material-ui/icons/TrendingDown';
import VerticalSplit from '@material-ui/icons/VerticalSplit';
import ViewList from '@material-ui/icons/ViewList';
import classNames from 'classnames';
import React, { Component } from 'react';
import { withUsuario } from '../../contexts/UsuarioContext';

import { Link } from 'react-router-dom';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import {
  Collapse,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    minWidth: 360,
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(2),
  },
  link: {
    textDecoration: 'none',
  },
  menuItem: {
    boxShadow: 'inset 4px 0 0 #4b4ba3',
    backgroundColor: '#eeeeee',
  },
  subMenuItem: {
    boxShadow: 'inset 4px 0 0 #4b4ba3',
    backgroundColor: '#f5f5f5',
  },
});

class DrawerList extends Component {
  state = {
    selectedIndex: 0,
    open: true,
  };

  handleListItemClick = (event, index) => {
    this.setState({
      selectedIndex: index,
      open: !(this.state.selectedIndex === index && this.state.open)
    });
  };

  render () {
    const listItem = [
      {
        index: 0,
        icon: <DashboardIcon />,
        navigation: '/dashboard',
        primaryText: 'Dashboard',
        exibir: true,
      },
      {
        index: 1,
        icon: <Attachment />,
        navigation: '/arquivoXML',
        primaryText: 'Envio de Faturamento',
        nested: [
          { icon: <Done />, 'navigation': '/validacao', primaryText: 'Validar Arquivo' },
          { icon: <CloudUpload />, 'navigation': '/envio', primaryText: 'Enviar Arquivo' },
          { icon: <Print />, 'navigation': '/impressao', primaryText: 'Imprimir Protocolos' },
          { icon: <Search />, 'navigation': '/lotes', primaryText: 'Consultar Lotes Enviados' },
          { icon: <Payment />, 'navigation': '/lotes', primaryText: 'Manter Lotes Recurso' },
        ],
        exibir:
          (this.props.isEmAlgumaRole && this.props.isPrestador && !this.props.isUnimed) ||
          (this.props.isEmAlgumaRole && !this.props.isPrestador && this.props.isGestor)
      },
      {
        index: 2,
        icon: <CloudQueue />,
        navigation: '/arquivoXMLUnimed',
        primaryText: 'Envio XML Unimed',
        nested: [
          { icon: <CloudUpload />, 'navigation': '/envio', primaryText: 'Enviar Arquivo' },
          { icon: <Print />, 'navigation': '/impressao', primaryText: 'Imprimir Protocolos' },
          { icon: <Search />, 'navigation': '/lotes', primaryText: 'Consultar Lotes Enviados' },
          { icon: <RemoveRedEye />, 'navigation': '/item_tabela', primaryText: 'Consultar Itens de Tabela' },
          { icon: <Loop />, 'navigation': '/faturas_em_avaliacao_CNU', primaryText: 'Em Avaliação CNU' },
          { icon: <ContactMail />, 'navigation': '/faturas_avaliacao_CNU_finalizada', primaryText: 'Avaliação CNU Finalizada' },
        ],
        exibir:
          (this.props.isEmAlgumaRole && this.props.isPrestador && this.props.isUnimed) ||
          (this.props.isEmAlgumaRole && !this.props.isPrestador && this.props.isGestor)
      },
      {
        index: 3,
        icon: <PeopleIcon />,
        navigation: '/beneficiario',
        primaryText: 'Beneficiário',
        nested: [
          { icon: <Face />, 'navigation': '/cadastro', primaryText: 'Novos' },
          { icon: <SwapHoriz />, 'navigation': '/fluxo', primaryText: 'Entradas e saídas' }
        ],
        exibir: this.props.isEmAlgumaRole && !this.props.isPrestador,
      },
      {
        index: 4,
        icon: <LocationCity />,
        navigation: '/prestador',
        primaryText: 'Prestadores',
        nested: [
          { icon: <LibraryAdd />, 'navigation': '/cadastro', primaryText: 'Novos' },
          { icon: <VerticalSplit />, 'navigation': '/grupo', primaryText: 'Grupos de Prestadores' },
          { icon: <Autorenew />, 'navigation': '/orgao_externo', primaryText: 'Prestador/Órgão Ext.' },
        ],
        exibir: this.props.isEmAlgumaRole && !this.props.isPrestador,
      },
      {
        index: 5,
        icon: <Gradient />,
        navigation: '/orcamento',
        primaryText: 'Pagamento',
        nested: [
          { icon: <Receipt />, 'navigation': '/demonstrativo', primaryText: 'Demonstrativos' },
          { icon: <Layers />, 'navigation': '/creditos', primaryText: 'Créditos Orçamentários', disabled: this.props.isEmAlgumaRole && this.props.isPrestador },
          { icon: <BarChart />, 'navigation': '/grafico', primaryText: 'Controle de gastos', disabled: this.props.isEmAlgumaRole && this.props.isPrestador },
        ],
        exibir:
          (this.props.isEmAlgumaRole && this.props.isPrestador && !this.props.isUnimed) ||
          (this.props.isEmAlgumaRole && !this.props.isPrestador && this.props.isGestor)
      },
      {
        index: 6,
        icon: <FormatLineSpacing />,
        navigation: '/auditoria',
        primaryText: 'Auditoria',
        nested: [
          { icon: <Search />, 'navigation': '/consultar', primaryText: 'Listar Todas as faturas' },
          { icon: <CalendarToday />, 'navigation': '/faturas_sem_data', primaryText: 'Listar Faturas Sem Data' },
          { icon: <AspectRatio />, 'navigation': '/faturas_sem_auditoria', primaryText: 'Listar Faturas Sem Auditoria' },
          { icon: <Create />, 'navigation': '/faturas_em_auditoria', primaryText: 'Auditar Guias' },
          { icon: <Loop />, 'navigation': '/faturas_em_avaliacao_CNU', primaryText: 'Em Avaliação CNU' },
          { icon: <ContactMail />, 'navigation': '/faturas_avaliacao_CNU_finalizada', primaryText: 'Avaliação CNU Finalizada' },
          { icon: <Gavel />, 'navigation': '/faturas_auditadas', primaryText: 'Liberar para Pagamento' },
          { icon: <Done />, 'navigation': '/faturas_liberadas', primaryText: 'Listar faturas Liberadas' },
        ],
        exibir: this.props.isEmAlgumaRole && !this.props.isPrestador,
      },
      {
        index: 7,
        icon: <Search />,
        navigation: '/consulta',
        primaryText: 'Consultas',
        nested: [
          { icon: <List />, 'navigation': '/extratos', primaryText: 'Extratos' },
          { icon: <SwapHoriz />, 'navigation': '/fluxo', primaryText: 'Entradas e Saídas' },
          { icon: <Rowing />, 'navigation': '/produtividade', primaryText: 'Produtividade da Auditoria' },
          { icon: <Accessibility />, 'navigation': '/fluxoPensionista', primaryText: 'Pensionistas' },
        ],
        exibir: this.props.isEmAlgumaRole && !this.props.isPrestador,
      },
      {
        index: 8,
        icon: <Assignment />,
        navigation: '/relatorio',
        primaryText: 'Relatorios',
        nested: [
          { icon: <TrendingDown />, 'navigation': '/dividas', primaryText: 'Dívidas' },
          { icon: <List />, 'navigation': '/dividas_detalhado', primaryText: 'Dívidas - Detalhado' },
          { icon: <Replay30 />, 'navigation': '/mensalidades', primaryText: 'Mensalidades' },
          { icon: <MonetizationOn />, 'navigation': '/coparticipacoes', primaryText: 'Coparticipação' },
          { icon: <CalendarViewDay />, 'navigation': '/calculo_atuarial', primaryText: 'Calc. Atualiral' },
          { icon: <Face />, 'navigation': '/relatorio_beneficiarios', primaryText: 'Beneficiários' },
          { icon: <Ballot />, 'navigation': '/declaracao_de_gastos', primaryText: 'Declaração de Gastos' },
          { icon: <AssignmentReturn />, 'navigation': '/reembolso', primaryText: 'Reembolsos' },
        ],
        exibir: this.props.isEmAlgumaRole && !this.props.isPrestador,
      },
      {
        index: 9,
        icon: <PersonAdd />,
        navigation: '/odontologico',
        primaryText: 'Odontológico',
        nested: [
          { icon: <Face />, 'navigation': '/cadastro', primaryText: 'Cadastro' },
        ],
        exibir: this.props.isEmAlgumaRole && !this.props.isPrestador,
      },
      {
        index: 10,
        icon: <ViewList />,
        navigation: '/tabelasApoio',
        primaryText: 'Tabelas de Apoio',
        nested: [
          { icon: <Settings />, 'navigation': '/parametros', primaryText: 'Parâmetros do Sistema' },
          { icon: <MonetizationOn />, 'navigation': '/faixaRemuneracao', primaryText: 'Faixas de Remuneração' },
          { icon: <DateRange />, 'navigation': '/faixaEtaria', primaryText: 'Faixas Etárias' },
          { icon: <Group />, 'navigation': '/tipoMensalidade', primaryText: 'Tipos de Mensalidade' },
          { icon: <Cached />, 'navigation': '/mensalidade', primaryText: 'Mensalidade e Reajuste' },
          { icon: <SwapVert />, 'navigation': '/limiteCobranca', primaryText: 'Limite de Cobrança' },
          { icon: <Assignment />, 'navigation': '/vigenciaPorte', primaryText: 'Vig. Porte Anest.' },
        ],
        exibir: this.props.isEmAlgumaRole && !this.props.isPrestador && this.props.isGestor,
      },
      {
        index: 11,
        icon: <AttachMoney />,
        navigation: '/financeiro',
        primaryText: 'Financeiro',
        nested: [
          { icon: <MonetizationOn />, 'navigation': '/calculoCoparticipacao', primaryText: 'Cálculo de Coparticipação - MED' },
          { icon: <AirlineSeatFlatAngled />, 'navigation': '/calculoCoparticipacaoOdonto', primaryText: 'Cálculo de Coparticipação - ODONTO' },
          { icon: <Autorenew />, 'navigation': '/acertoMensalidade', primaryText: 'Acerto de Mensalidade' },
          { icon: <Receipt />, 'navigation': '/acertoCoparticipacao', primaryText: 'Acerto de Coparticipação' },
          { icon: <AspectRatio />, 'navigation': '/acertosDiversos', primaryText: 'Acertos Diversos' },
          { icon: <Person />, 'navigation': '/dividaServDesligado', primaryText: 'Dívidas Serv. Deslig.' },
          { icon: <Payment />, 'navigation': '/dividaServDesligadoPagto', primaryText: 'Pagtos. Serv. Deslig.' },
          { icon: <AssignmentReturn />, 'navigation': '/reembolsoMedico', primaryText: 'Reembolso Médico' },
          { icon: <Assignment />, 'navigation': '/assistenciaOdontologica', primaryText: 'Assistência Odontológica' },
          { icon: <Face />, 'navigation': '/dentista', primaryText: 'Dentistas/Consultórios' },
        ],
        exibir: this.props.isEmAlgumaRole && !this.props.isPrestador && this.props.isGestor,
      },

    ];

    const { classes, menuAppOpen } = this.props;
    const { selectedIndex, open } = this.state;

    return (
      <div className={classes.root}>
        <MenuList>
          {listItem.map((item, idx) =>
            item.exibir &&
            <div key={idx}>
              <Link to={item.navigation} className={classes.link}>
                <MenuItem
                  // button
                  className={(selectedIndex === item.index) ? classes.menuItem : null}
                  selected={selectedIndex === item.index}
                  onClick={event => this.handleListItemClick(event, item.index)}
                >
                  {!menuAppOpen ? <Tooltip title={item.primaryText} placement='right'>
                    <ListItemIcon>
                      {item.icon}
                    </ListItemIcon>
                  </Tooltip>
                    : <ListItemIcon>
                      {item.icon}
                    </ListItemIcon>
                  }
                  <ListItemText primary={item.primaryText} />
                  {item.nested ? (selectedIndex === item.index && open ? <ExpandLess /> : <ExpandMore />) : null}
                </MenuItem>
              </Link>
              {item.nested
                ? <Collapse in={selectedIndex === item.index && open} timeout='auto' unmountOnExit>
                  <MenuList disablePadding>
                    {item.nested.map((nested, idx) =>                      
                      !nested.disabled && <Link to={nested.navigation ? `${item.navigation}${nested.navigation}` : `${item.navigation}`} key={idx} className={classes.link}>
                        <MenuItem className={classNames(classes.nested, (selectedIndex === item.index) ? classes.subMenuItem : null)} button>
                          {!menuAppOpen ? 
                          <Tooltip title={nested.primaryText} placement='right'>
                            <ListItemIcon>
                              {nested.icon}
                            </ListItemIcon>
                          </Tooltip>
                            : <ListItemIcon>
                              {nested.icon}
                            </ListItemIcon>
                          }
                          <ListItemText secondary={nested.primaryText} />
                        </MenuItem>
                      </Link>
                    )}
                  </MenuList>
                </Collapse>
                : null}
            </div>
          )}
        </MenuList>
      </div>
    );
  }
}

export default withUsuario(withStyles(styles)(DrawerList));
